import { publicClient, privateClient } from './client';
import { DeliveryType } from './DeliveryType';

const customDeliveryType = (pub: boolean) => new DeliveryType(pub ? publicClient : privateClient);
export default customDeliveryType;
